import { appContext } from "../../../AppContext";
import { IbssComponent } from "../../Core/BaseComponent/IbssComponent"
import { PasswordDialog } from "./PasswordDialog";
import { DiagnosticsDialog } from "./DiagnosticsDialog";
import { JSX } from "react";
import { ThemeDialog } from "./ThemeDialog";
import { ThemeId } from "../../../Common/CustomTheme";
import { SerendieSymbol } from "@serendie/symbols";
import { List } from "@iconics/components";
import { ListItem } from "@iconics/components";
import { Button, LanguageDialog } from "@iconics/components";

export default class Menu extends IbssComponent<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state = {
            themeId: 'konjo',
            showMenu: false,
            showDiagnosticsDialog: false,
            showPasswordDialog: false,
            showThemeDialog: false,
            showLanguageDialog: false,
        };
    }

    public componentDidMount(): void
    {
        appContext().state.autoMap(this, i => ({ themeId: i.themeId }));
    }

    public render(): JSX.Element
    {
        const { labels, localStorageProvider } = appContext();
        const userDetails = localStorageProvider.getUserDetails();

        return (
            <>
                <Button
                    className="header__account-menu"
                    onClick={() => this.setState({ showMenu: !this.state.showMenu })}
                    aria-label='profile menu'
                    aria-expanded={this.state.showMenu}
                    styleType='ghost'
                >
                    <SerendieSymbol name='user' className="header__account-menu-user" />
                    <span className="header__account-menu-name">{userDetails.displayName}</span>
                    <SerendieSymbol name={this.state.showMenu ? 'chevron-up' : 'chevron-down'} className="header__account-menu-expand" />
                </Button>
                {this.state.showMenu && (
                    <List
                        className="header__options"
                        id="myDropdown"
                        onMouseLeave={() => this.setState({ showMenu: !this.state.showMenu })}
                    >
                        <ListItem
                            title={labels.Platform_UserMenu_ChangeTheme}
                            leftIcon={<SerendieSymbol name='moon' />}
                            className="header__option"
                            onClick={() => this.setState({ showThemeDialog: true })}
                        />
                        <ListItem
                            title={labels.Platform_UserMenu_ChangeLanguage}
                            leftIcon={<SerendieSymbol name='type' />}
                            className="header__option"
                            onClick={() => this.setState({ showLanguageDialog: true })}
                        />
                        {userDetails.userType === "Native" &&
                            <ListItem
                                title={labels.Platform_UserMenu_ChangePassword}
                                leftIcon={<SerendieSymbol name='lock' />}
                                className="header__option"
                                onClick={() => this.setState({ showPasswordDialog: true })}
                            />
                        }

                        <ListItem
                            title={labels.Platform_UserMenu_Diagnostics}
                            leftIcon={<SerendieSymbol name='information' />}
                            className="header__option"
                            onClick={() => this.setState({ showDiagnosticsDialog: true })}
                        />
                        <ListItem
                            title={labels.Platform_UserMenu_Logout}
                            leftIcon={<SerendieSymbol name='logout' />}
                            className="header__option"
                            onClick={() => appContext().authentication.logOut()}
                        />
                    </List>
                )}

                <DiagnosticsDialog
                    open={this.state.showDiagnosticsDialog}
                    onClose={() => this.setState({ showDiagnosticsDialog: false })}
                />

                <PasswordDialog
                    open={this.state.showPasswordDialog}
                    onClose={() => this.setState({ showPasswordDialog: false })}
                />

                <LanguageDialog
                    open={this.state.showLanguageDialog}
                    onClose={() => this.setState({ showLanguageDialog: false })}
                    getCurrentLanguage={() => Promise.resolve(appContext().language.current)}
                    localisation={appContext().localisation}
                />

                <ThemeDialog
                    open={this.state.showThemeDialog}
                    onClose={() => this.setState({ showThemeDialog: false })}
                />
            </>
        );
    }
}

export interface IProps { }

export interface IState
{
    themeId: ThemeId;
    showMenu: boolean;
    showDiagnosticsDialog: boolean;
    showPasswordDialog: boolean;
    showThemeDialog: boolean;
    showLanguageDialog: boolean;
}
